import axios from './axios'

export default {
  install (Vue) {
    axios(Vue)
  }
}



// WEBPACK FOOTER //
// ./src/libraries/plugins/index.js